module.exports = __webpack_public_path__ + "media/images/talent/case02-badge-7fcdf422dd588ad842714359cdcbea13.png";